import { ofType, ActionsObservable } from "redux-observable";
import { switchMap, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { AppStats } from "../actions";
import { API_URL } from "../config/settings";
import { Headers } from "../utilites/Headers";

// ✅ KEEP: General app stats
export const getStatsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_STATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/stats/count`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_STATS_SUCCESS,
              payload: response,
            });
            if (payload.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );

// ✅ KEEP: Mutual management invitations
export const getMutualManagementsEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.GET_MUTUAL_MANAGEMENT),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/stats/mutual-management`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.GET_MUTUAL_MANAGEMENT_SUCCESS,
              payload: response.invitations,
              key: "invitations",
            });
            if (payload.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );

// ✅ KEEP: Co-management invitations
export const coManagementEpic = (action$) =>
  action$.pipe(
    ofType(AppStats.CO_MANAGEMENT_STATUS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/stats/co-management`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: AppStats.CO_MANAGEMENT_STATUS_SUCCESS,
              payload: response.invitations,
              key: "coInvitations",
            });
            if (payload.onSuccess) payload.onSuccess(response);
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            console.log(err);
            obs.complete();
          })
        )
      )
    )
  );

// ❌ REMOVED: All community epics moved to communities.js
// export const getNeighborsNoticesEpic = ...
// export const getCommunityAggregatedStatsEpic = ...
